module.exports = "## Supported Units for Resizing\r\n\r\nCurrently, you can perform image resize in cm, mm, inches, pixels, or as a percentage of the original image. If you select a length unit such as; cm, mm, or inches, we will also specify the DPI of the image (dots per inch) in image metadata so that print devices can potentially use this information for printing your image at your specified length."


//////////////////
// WEBPACK FOOTER
// ./src/containers/ImageResize/supported-units-for-resizing.md
// module id = 1180
// module chunks = 0